export default class InvoiceIndex {

    constructor() {
        this.datatable = null;
        this.bindEvents();
        this.initDataTable();
        //window.application.setOnDataChangeListener(this);
    }

    initDataTable() {
        if (document.getElementById('invoices-datatable')) {
            this.datatable = $('#invoices-datatable').DataTable({
                responsive: true,
                order: [[1, 'desc']], // Order by date column descending
                columnDefs: [
                    { orderable: false, targets: [2] } // Disable ordering on actions column
                ],
                language: {
                    url: '/data-tables/locales/' + I18n.locale + '.json'
                }
            });
        }
    }

    bindEvents() {
        // Handle fetch invoices button
        const fetchBtn = document.getElementById('fetch-invoices-btn');
        if (fetchBtn) {
            fetchBtn.addEventListener('click', this.handleFetchInvoices.bind(this));
        }
    }

    handleFetchInvoices() {
        const modal = $('#fetchInvoicesModal');
        const fetchBtn = document.getElementById('fetch-invoices-btn');
        const fetchUrl = fetchBtn.getAttribute('data-fetch-url');

        if (!fetchUrl) {
            console.error('Fetch URL not found in data attribute');
            this.showNotification('error', 'Erreur de configuration');
            return;
        }

        // Show modal
        modal.modal('show');

        // Make AJAX request to fetch invoices
        fetch(fetchUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        })
        .then(response => response.json())
        .then(data => {
            modal.modal('hide');
            
            if (data.success) {
                // Show success message
                this.showNotification('success', data.message || 'Factures récupérées avec succès');
                // Reload page to show new invoices
                setTimeout(() => window.location.reload(), 1500);
            } else {
                this.showNotification('error', data.error || 'Erreur lors de la récupération des factures');
            }
        })
        .catch(error => {
            modal.modal('hide');
            this.showNotification('error', 'Erreur de connexion');
            console.error('Error:', error);
        });
    }

    showNotification(type, message) {
        // Simple notification system - you can customize this based on your existing notification system
        const alertClass = type === 'success' ? 'alert-success' : 'alert-danger';
        const notification = document.createElement('div');
        notification.className = `alert ${alertClass} alert-dismissible fade show position-fixed`;
        notification.style.cssText = 'top: 20px; right: 20px; z-index: 9999; min-width: 300px;';
        notification.innerHTML = `
            ${message}
            <button type="button" class="close" data-dismiss="alert">
                <span>&times;</span>
            </button>
        `;
        
        document.body.appendChild(notification);
        
        // Auto-remove after 5 seconds
        setTimeout(() => {
            if (notification.parentNode) {
                notification.parentNode.removeChild(notification);
            }
        }, 5000);
    }

    onDataChanged(data) {
    }

    onDestroy() {
        if (this.datatable) {
            this.datatable.destroy();
        }
    }
}